export const paginationSelectBoxStyles = {
    container: (style: any) => ({
        ...style,
        width: "100%",
    }),
    control: (style: any) => ({
        ...style,
        minHeight: "40px",
        borderRadius: "5px",
        border: "1px solid #ced4da;",
        fontStyle: 'Roboto',
        fontSize: "13px",
        color: "rgba(0, 0, 0, 0.5);",
        width: '80px',
    }),
    menuList: (style: any) => ({
        ...style,
        maxHeight: '120px',
    }),
    menu: (style: any) => ({
        ...style,
        width: "100%",
        fontSize: "13px",
        maxHeight: '120px',
    }),
    indicatorSeparator: () => ({
        display: "none",
    })
}
